import {useContext, useEffect} from 'react';

import {CalendarPanelType} from '../../page/main/posts/calendar/posts-calendar-type';
import {MainFilterContext} from '../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../provider/main-filter/main-filter-type';
import {useUser} from '../../provider/user/user-hook';
import {useApiHooks} from '../api-hook/api-hook';
import {UseHookType} from '../api-hook/api-hook-type';
import {HelpLinkFeatureFlagEnum} from '../feature-flags/feature-flag-const';
import {useFeatureFlag} from '../feature-flags/use-feature-flag';

import {getPublicationsCalendar} from './publications-calendar-api';
import {
    CalendarPublicationsRequestParametersType,
    CalendarPublicationsResponseType,
} from './publications-calendar-type';

// Promotions and Events live behind the publication-catalog rollout flag; while it is off there is
// nowhere for a calendar entry to link to, so the request is not made at all.
export function usePublicationsCalendar(panel: CalendarPanelType): UseHookType<CalendarPublicationsResponseType> {
    const {isInProgress, setIsInProgress, result, setResult, processError, setProcessError, reset} =
        useApiHooks<CalendarPublicationsResponseType>();

    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const {user} = useUser();

    const isPublicationCatalogEnabled = useFeatureFlag(HelpLinkFeatureFlagEnum.publicationCatalog);

    useEffect(() => {
        if (!isPublicationCatalogEnabled) {
            return;
        }

        setIsInProgress(true);

        const parameters: CalendarPublicationsRequestParametersType = {
            year: panel.date.year(),
            month: panel.mode === 'month' ? panel.date.month() + 1 : null,
        };

        getPublicationsCalendar(parameters, user?.isDemoCpUser ? '' : mainFilterKey)
            .then(setResult)
            .finally(() => setIsInProgress(false))
            .catch(setProcessError);
    }, [setIsInProgress, setResult, setProcessError, panel, user, mainFilterKey, isPublicationCatalogEnabled]);

    return {
        isInProgress,
        processError,
        result,
        reset,
    };
}
